// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application'

import AlertController from './alert_controller'

import AppendFrameController from './append_frame_controller'

import AutofocusController from './autofocus_controller'

import ChartkickController from './chartkick_controller'

import CollapseController from './collapse_controller'

import ColorSchemeController from './color_scheme_controller'

import EditorController from './editor_controller'

import FlatpickrController from './flatpickr_controller'

import FormController from './form_controller'

import GoogleAnalyticsController from './google_analytics_controller'

import GoogleChartsController from './google_charts_controller'

import GoogleMapsController from './google_maps_controller'

import IntercomController from './intercom_controller'

import LazyController from './lazy_controller'

import MenuToggleController from './menu_toggle_controller'

import PrintController from './print_controller'

import RecaptchaController from './recaptcha_controller'

import ReloadFrameController from './reload_frame_controller'

import RemoveFrameController from './remove_frame_controller'

import SelectTabController from './select_tab_controller'

import SportController from './sport_controller'

import StripeCheckoutController from './stripe_checkout_controller'

import StripeCheckoutRegistrationController from './stripe_checkout_registration_controller'

import TimeController from './time_controller'

import ToggleCheckboxController from './toggle_checkbox_controller'

import ToggleChoiceController from './toggle_choice_controller'

import ToggleController from './toggle_controller'

import ToggleSelectController from './toggle_select_controller'

import ReloadController from './reload_controller'

application.register('alert', AlertController)
application.register('append-frame', AppendFrameController)
application.register('autofocus', AutofocusController)
application.register('chartkick', ChartkickController)
application.register('collapse', CollapseController)
application.register('color-scheme', ColorSchemeController)
application.register('editor', EditorController)
application.register('flatpickr', FlatpickrController)
application.register('form', FormController)
application.register('google-analytics', GoogleAnalyticsController)
application.register('google-charts', GoogleChartsController)
application.register('google-maps', GoogleMapsController)
application.register('intercom', IntercomController)
application.register('lazy', LazyController)
application.register('menu-toggle', MenuToggleController)
application.register('print', PrintController)
application.register('recaptcha', RecaptchaController)
application.register('reload-frame', ReloadFrameController)
application.register('remove-frame', RemoveFrameController)
application.register('select-tab', SelectTabController)
application.register('sport', SportController)
application.register('stripe-checkout', StripeCheckoutController)
application.register('stripe-checkout-registration', StripeCheckoutRegistrationController)
application.register('time', TimeController)
application.register('toggle-checkbox', ToggleCheckboxController)
application.register('toggle-choice', ToggleChoiceController)
application.register('toggle', ToggleController)
application.register('toggle-select', ToggleSelectController)
application.register('reload', ReloadController)
